<template>
  <div>
    <label :for="field.id">{{ field.label[currentLanguage] }} <span v-if="field.required" class="required">*</span></label>
    <label v-for="(option, index) in field.options" :key="index" :for="'id_' + field.id + '_i_' + index" class="control radio">
      <input :name="field.name + index" :checked="value === option.value" :value="option.value" @change="$emit('input', $event.target.value);$emit('change', '')" type="radio" :id="'id_' + field.id + '_i_' + index" :readonly="field.readonly" :disabled="disabledStatus(field.disabled)">
      <span class="control-indicator"></span>
      <span class="control-label">{{ option.label[currentLanguage] }}</span>
    </label>
    <p class="small" v-if="field.description[currentLanguage]">{{ field.description[currentLanguage] }}</p>
  </div>
</template>

<script>
export default {
  props: ['value', 'field', 'currentLanguage', 'disabledStatus']
}
</script>



// WEBPACK FOOTER //
// src/components/elements/radio.vue